module.exports = __webpack_public_path__ + "img/img1.b7e7d754.png";